<template>
  <div class="container-fluid">
    <h2>Datenabgleich</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button id="start" @click="startSync" class="btn btn-primary"><font-awesome-icon icon="play"/>&nbsp;Starten</button>
        <button id="selall" @click="allActions" class="btn btn-secondary"><font-awesome-icon icon="list"/>&nbsp;Alles auswählen</button>
        <button id="reset" @click="resetTimestamps" class="btn btn-secondary"><font-awesome-icon icon="redo"/>&nbsp;Zeitstempel zurücksetzen</button>
      </div>
    </div>
    <br/>
    <div style="max-width:250px;" class="form-check">
      <input class="form-check-input" v-model="actions" value="bshop" id="bshop-sync" type="checkbox"/>
      <label class="form-check-label" for="bshop-sync">bShop mit Aktualisieren</label>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="row">
          <div class="col-md">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="form-check">
                  <input value="article" id="article-sync" v-model="actions" type="checkbox" class="form-check-input">
                  <label class="form-check-label" for="article-sync">Artikeldaten</label>
                  <small class="form-text text-muted">Letzter Lauf: <span id="timearticle">{{ lastruns.article }}</span></small>
                </div>
              </li>
              <li class="list-group-item list-group-item-secondary">
                <div class="form-check">
                  <input id="price-sync" v-model="actions" value="price" type="checkbox" class="form-check-input">
                  <label class="form-check-label" for="price-sync">Preisdaten</label>
                  <small class="form-text text-muted">Letzter Lauf: <span id="timeprice">{{ lastruns.price }}</span></small>
                </div>
              </li>
              <li class="list-group-item">
                <div class="form-check">
                  <input id="customer-sync" v-model="actions" value="customer" type="checkbox" class="form-check-input">
                  <label class="form-check-label" for="customer-sync">Kundendaten</label>
                  <small class="form-text text-muted">Letzter Lauf: <span id="timecustomer">{{ lastruns.customer }}</span></small>
                </div>
              </li>
              <li class="list-group-item list-group-item-secondary">
                <div class="form-check">
                  <input id="order-sync" v-model="actions" value="order" type="checkbox" class="form-check-input">
                  <label class="form-check-label" for="order-sync">Auftragsdaten</label>
                  <small class="form-text text-muted">Letzter Lauf: <span id="timeorder">{{ lastruns.order }}</span></small>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="form-check">
                  <input id="costcentre-sync" v-model="actions" value="bshopdata" type="checkbox" class="form-check-input"/>
                  <label class="form-check-label" for="costcentre-sync">Kostenstellen / Budget</label>
                  <small class="form-text text-muted">Letzter Lauf: <span id="timebshopdata">{{ lastruns.costcentre }}</span></small>
                </div>
              </li>
              <li class="list-group-item list-group-item-secondary">
                <div class="form-check">
                  <input id="config-sync" v-model="actions" value="config" type="checkbox" class="form-check-input">
                  <label class="form-check-label" for="config-sync">Konfiguration</label>
                  <small class="form-text text-muted">Letzter Lauf: <span id="timeconfig">{{ lastruns.config }}</span></small>
                </div>
              </li>
              <li class="list-group-item">
                <div class="form-check">
                  <input id="media-sync" v-model="actions" value="media" type="checkbox" class="form-check-input">
                  <label class="form-check-label" for="media-sync">Multimedia</label>
                  <small class="form-text text-muted">Letzter Lauf: <span id="timemedia">{{ lastruns.media }}</span></small>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-header">Laufende Jobs:</div>
          <div class="card-body">
            <ul id="runs" class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(val,key) in running" :key="key">
                <span>{{ val.name }}</span>
                <span>{{ val.start }}</span>
                <font-awesome-icon spin icon="spinner"/>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    <b-tabs>
      <b-tab title="Log Meldungen">
        <LiveLogView/>
      </b-tab>
      <b-tab title="Fehler / Warnungen">
        <SysMsgView class="mt-3"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import datasync from '@/modules/datasync.js'
import LiveLogView from '@/components/admin/sys/LiveLogView.vue'
import SysMsgView from '@/components/admin/sys/SysMsgView.vue'

export default {
  name: 'DataSyncControl',
  components: {
    LiveLogView,
    SysMsgView,
  },
  created: function() {
    this.updateiv = setInterval(this.updateStatus.bind(this), 3000);
    this.updateStatus();
  },
  data() {
    return {
      lastruns: {},
      running: {},
      actions: [],
      updateiv: false
    }
  },
  beforeDestroy: function() {
    console.log('destroy sync');
    if (this.updateiv) {
      console.log('rem interval check');
      clearInterval(this.updateiv);
    }
  },
  methods: {
    updateStatus() {
      var self = this;
      datasync.loadinfo(this,function(data) {
        console.log(data);
        if (data.lastruns) self.lastruns = data.lastruns;
        if (data.running) self.running = data.running;
      })
    },
    allActions: function() {
      this.actions = ["bshop","article","customer","price","order","config","media"];
    },
    startSync: function() {
      var self = this;
      datasync.startsync(this,this.actions,function(data) {
        self.$bvToast.toast(data.message,{title:'Synchronisation',variant:"success"});
        self.updateStatus();
      })
    },
    resetTimestamps() {
      var self = this;
      datasync.resettimestamps(this,function() {
        self.$bvToast.toast('Zeitstempel zurück gesetzt.',{title:'Datenabgleich',variant:'success'});
      })
    }
  }
}
</script>
